<template>
  <!-- <div style="margin-top: 5%" class=" mx-auto"> -->

  <v-content>
    <v-container class="fill-height">
      <v-card tile style="margin-top: 2%" class="d-flex mx-auto flex-wrap">
        <v-sheet
          tile
          color="rgb(0, 155, 217)"
          width="auto"
          class="pa-5 white--text overflow-hidden flex-fill"
        >
          <v-card-text class="headline text-center" mt-2>
            <img :src="require(`@/assets/${logo}`)" width="235" />
            <div>
              <!-- <span class="headline white--text font-weight-light">FIRELOG</span> -->
            </div>
            <v-menu transition="scale-transition" origin="right top" offset-y>
              <template v-slot:activator="{ on }">
                <v-btn text v-on="on" class="white--text">
                  <template>{{$i18n.locale}}</template>
                  <v-spacer></v-spacer>
                  <v-icon>language</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(language, index) in $store.state.languages"
                  :key="index"
                  @click="changeLanguage(language.code)"
                >
                  <v-list-item-icon>{{ fromCodePoint(language.flag) }} {{language.name}}</v-list-item-icon>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-card-text>
          <!-- <img src="@/assets/logo.png" width="55" />
          FIRELOG-->
          <!-- <img src="@/assets/firelogdemo.png" /> -->
          <p class="headline mt-2">{{$t('takealook')}}</p>

          <v-list color="transparent" nav dense>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="white">fa-check-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="white--text text-wrap">{{$t('manufacturerIndepentent')}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="white">fa-check-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="white--text text-wrap">{{$t('multiplesealsonmarker')}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="white">fa-check-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="white--text text-wrap">{{$t('anydevice')}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="white">fa-check-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="white--text text-wrap">{{$t('multilanguage')}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="white">fa-check-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="white--text text-wrap">{{$t('highlyCustomizable')}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-sheet>
        <v-sheet
          color="transparent"
          class="pa-3 mx-auto my-auto white--text overflow-hidden flex-fill"
          max-width="450"
          min-width="300"
        >
        <transition name="component-fade" mode="out-in">
          <div v-if="!forgot">
            <v-tabs v-model="tab" hide-slider grow dark>
              <v-tabs-slider></v-tabs-slider>

              <v-tab active-class="secondary" href="#1">{{$t('signup')}}</v-tab>

              <v-tab active-class="secondary" href="#2">{{$t('login')}}</v-tab>
            </v-tabs>

            <v-tabs-items class="transparent" v-model="tab">
              <v-tab-item value="1">
                <div color="transparent" class="mt-2">
                  <signup></signup>
                </div>
              </v-tab-item>
              <v-tab-item value="2">
                <div color="transparent" class="mt-6">
                  
                    <login v-on:forgot="forgot = true"></login>
                  
                </div>
              </v-tab-item>
            </v-tabs-items>
          </div>
          <forgotPassword v-else v-on:login="forgot = false"></forgotPassword>
          </transition>
        </v-sheet>
      </v-card>
    </v-container>
  </v-content>

  <!-- </div> -->
</template>

<script>
import jwtdecode from "jwt-decode";
import sha256 from "sha256";
import login from "@/components/Pages/Authentication/Login";
import signup from "@/components/Pages/Authentication/Signup";
import forgotPassword from "@/components/Pages/Authentication/ForgotPassword";

export default {
  name: "Login",
  data() {
    return {
      tab: null,
      forgot: false
    };
  },
  computed: {
    logo: function () {
      console.log(`Host is ${window.location.host}`);
      if (window.location.host.includes('sbk')) {
        return "sbklogo.jpg";
      } else {
        return "logo_with_text.png";
      }
    }
  },
  components: {
    login,
    signup,
    forgotPassword
  },
  beforeRouteEnter(to, from, next) {
    document.body.className = "login";
    if (from.name !== "Login" && from.name !== null) {
      localStorage.removeItem("auth");
      localStorage.removeItem("user");
    }
    next(vm => {
      // access to component instance via `vm`
      if (localStorage.getItem("auth") != null) {
        vm.$router.push({ name: "Projects" });
      } else {
        next();
      }
    });
  },
  beforeRouteLeave(to, from, next) {
    document.body.className = "home";
    next();
  },
  methods: {
    changeLanguage(language) {
      this.$i18n.locale = language;
      localStorage.setItem("language", language);
    },
    fromCodePoint(codepoint) {
      if (codepoint.split(" ").length > 0) {
        return (
          String.fromCodePoint(codepoint.split(" ")[0]) +
          String.fromCodePoint(codepoint.split(" ")[1])
        );
      }
      return String.fromCodePoint(codepoint);
    }
  },
  beforeCreate: function() {
    document.body.className = "login";
  }
};
</script>

<style scoped>
.v-card {
  height: auto;
}
</style>


<style scoped>
.v-content__wrap {
  background: linear-gradient(-45deg, #ee7752, #009bd9, #009bd9, #23d5ab);
  background-size: 400% 400%;
  animation: gradient 15s ease infinite;
}
@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.component-fade-enter-active, .component-fade-leave-active {
  transition: opacity .3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/views/authentication/Login.vue